module.exports = __webpack_public_path__ + "img/timeline_miscevent-14.6750648a.jpg";